import React from 'react';
import { cn } from '@/lib/utils';
import { MarkdownText } from './MarkdownText';

interface AssistantMessageProps {
  content: string;
  className?: string;
}

export const AssistantMessage = React.memo<AssistantMessageProps>(({ content, className }) => {
  return (
    <div className={cn("flex justify-start mb-4", className)}>
      <div className="max-w-[80%]">
        <MarkdownText content={content} />
      </div>
    </div>
  );
});
AssistantMessage.displayName = 'AssistantMessage';

